import { render, staticRenderFns } from "./ClujiTimeline.vue?vue&type=template&id=717ef1b1&scoped=true"
import script from "./ClujiTimeline.vue?vue&type=script&lang=js"
export * from "./ClujiTimeline.vue?vue&type=script&lang=js"
import style0 from "./ClujiTimeline.vue?vue&type=style&index=0&id=717ef1b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717ef1b1",
  null
  
)

export default component.exports